(function () {
  if (window.VilaMarketMoney) return;

  var reconvertTimer = null;
  var reconvertAttempts = 0;
  var MAX_RECONVERT_ATTEMPTS = 600;

  function normalizeBaseText(value) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    var rsdMatch = text.match(/^(-?[\d.\s]+(?:,\d+)?)\s*RSD$/i);

    if (rsdMatch) {
      // Serbian thousands separators (for example "2.150 RSD") are read by
      // BUCKS as decimal points. Feed BUCKS an ungrouped base value instead.
      var ungroupedAmount = rsdMatch[1]
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
      var numericAmount = Number(ungroupedAmount);

      if (Number.isFinite(numericAmount)) return formatBasePrice(numericAmount);
    }

    return text;
  }

  function formatBasePrice(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) amount = 0;

    // No grouping separator here: this is a machine-readable value for BUCKS,
    // not the final customer-facing format.
    return Math.round(amount).toString() + ' RSD';
  }

  function runBucksReconvert() {
    var bucks = window.bucksCC;

    if (bucks && typeof bucks.reConvert === 'function') {
      reconvertTimer = null;
      reconvertAttempts = 0;
      bucks.reConvert();
      return;
    }

    reconvertAttempts += 1;
    if (reconvertAttempts >= MAX_RECONVERT_ATTEMPTS) {
      reconvertTimer = null;
      reconvertAttempts = 0;
      return;
    }

    reconvertTimer = window.setTimeout(runBucksReconvert, 100);
  }

  function requestReconvert() {
    if (reconvertTimer !== null) return;

    reconvertAttempts = 0;
    reconvertTimer = window.setTimeout(runBucksReconvert, 0);
  }

  function setBaseText(element, value) {
    if (!element) return false;

    var baseText = normalizeBaseText(value);
    if (!baseText) return false;

    element.classList.add('money');

    // BUCKS changes textContent when it converts a price. Keeping the original
    // RSD value separately stops buybox observers from overwriting that result.
    if (element.dataset.vilaBaseMoney === baseText) return false;

    element.dataset.vilaBaseMoney = baseText;
    element.textContent = baseText;
    requestReconvert();
    return true;
  }

  function setBasePrice(element, value) {
    return setBaseText(element, formatBasePrice(value));
  }

  window.VilaMarketMoney = {
    formatBasePrice: formatBasePrice,
    requestReconvert: requestReconvert,
    setBasePrice: setBasePrice,
    setBaseText: setBaseText
  };
})();
